import React, { useCallback, useContext } from 'react'
import { PlayerProfileContext } from '../../Context'
import { PageHeader } from '../../Components/Headers'
import { Box, BottomAppCallout, PageContainerMain } from '../../Components/Layout'
import { PlayerLinkBar } from './components'
import { ProfileTab } from './ProfileTab'
import { StatsTab } from './StatsTab'
import { createPlayerDynamicLink, generatePlayerSEOTags } from '../../Utils'
import { AutocompleteContainer } from '../../Components/Search'
import { UpcomingGames } from './components/UpcomingGames/UpcomingGames'
import { AdUnit } from '../../Components/Ads/AdUnit'
import { SEOTags } from '../../Components/SEO/SEOTags'
import { HelmetProvider } from 'react-helmet-async'
import { PlayerDataGQL } from '../../Api'

const Player: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { player, playerEvents, params, urls } =
    useContext(PlayerProfileContext)!

  const getSEO = useCallback(
    (tag: 'title' | 'description' | 'keywords', player: PlayerDataGQL | null) => {
      if (!player) return
      const generatedTags = generatePlayerSEOTags(player, params?.tab)

      return generatedTags[tag]
    },
    [player, params?.tab]
  )

  return (
    <HelmetProvider>
      {player && player?.firstName && player?.lastName && (
        <SEOTags
          title={getSEO('title', player)}
          description={getSEO('description', player)}
          keywords={getSEO('keywords', player)}
        />
      )}
      <PageContainerMain>
        {urls?.teamBanner && <PageHeader img={urls.teamBanner} />}
        <AutocompleteContainer />
        <AdUnit bannerType="bannerMain" aria-label="Player page ad" />
        <>
          {player && (
            <>
              <Box>
                <PlayerLinkBar />
              </Box>
              {playerEvents.length > 0 && <UpcomingGames />}

              {params?.tab === 'profile' && <ProfileTab />}
              {params?.tab === 'stats' && <StatsTab />}
            </>
          )}
        </>
      </PageContainerMain>
      {params?.tab === 'profile' && player?.slug && (
        <BottomAppCallout
          text={`View his profile in the PLL App`}
          appLink={createPlayerDynamicLink(player, 'profile', true)}
          location={`${player.slug}_profile_page`}
        />
      )}
      {params?.tab === 'stats' && player?.slug && (
        <BottomAppCallout
          text={`View his stats in the PLL App`}
          appLink={createPlayerDynamicLink(player, 'stats', true)}
          location={`${player.slug}_stats_page`}
        />
      )}
    </HelmetProvider>
  )
}

export default Player
